var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpcBennet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#3a2834;}.cls-3{fill:#33222e;}.cls-4{fill:#4c3547;}.cls-5{fill:#2d1f29;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "440.29 285.27 353.34 209.18 266.39 285.11 353.41 466.07 440.29 285.27"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "266.16 355.17 353.04 389.09 440.07 355.17 481.14 451.71 225.69 452.04 266.16 355.17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233.72 468.13 470.87 468.13 481.14 451.71 225.51 451.71 233.72 468.13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "307.16 497.47 398 497.47 409.39 476.88 296.7 476.88 307.16 497.47"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "267.5 483.26 437.11 483.26 448.81 467.62 257.85 467.62 267.5 483.26"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "322.07 452.36 225.36 452.04 252.08 261.87 301.6 219.96 322.07 452.36"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "384.57 452.36 481.29 452.04 454.57 261.87 405.04 219.96 384.57 452.36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpcBennet);
export default __webpack_public_path__ + "static/media/npc-bennet.737ee7b587bb5ddf34b2d3b502ee1fd9.svg";
export { ForwardRef as ReactComponent };